import { NHSApp } from "../types/nhsAppJs"

export const mockNHSJavascript = (inNHSApp: boolean): NHSApp => {
  return {
    callbacks: {
      back: () => console.log("Going back in NHSapp"),
    },
    navigation: {
      goToPage: (page: string) => console.log("go to page in NHSapp:", page),
      goToHomepage: () => console.log("Going to home page in NHSapp"),
      setBackAction: function (_callback: () => void): void {
        throw new Error("Function not implemented.")
      },
      clearBackAction: function (): void {
        throw new Error("Function not implemented.")
      },
      goToGpRegStartPage: function (_page: string): void {
        throw new Error("Function not implemented.")
      },
      openBrowserOverlay: function (_url: string): void {
        throw new Error("Function not implemented.")
      },
      openExternalBrowser: function (_url: string): void {
        throw new Error("Function not implemented.")
      },
      AppPage: {
        HOME_PAGE: "homePage",
        SERVICES: "services",
        YOUR_HEALTH: "your-health",
        MESSAGES: "messages",
        SETTINGS: "settings",
        MORE: "more",
        UPLIFT: "uplift",
        GO_BACK: "goBack",
      },
    },
    tools: {
      getAppPlatform: () => "Android",
      isOpenInNHSApp: () => inNHSApp,
    },
    storage: {
      addEventToCalendar: function (
        _subject: string,
        _body: string,
        _location: string,
        _startTimeEpochInSeconds: number,
        _endTimeEpochInSeconds?: number,
      ): void {
        throw new Error("Function not implemented.")
      },
      downloadFromBytes: function (_base64Data: string, _fileName: string, _mimeType: string): void {
        throw new Error("Function not implemented.")
      },
    },
  }
}
